module.exports = __webpack_public_path__ + "img/file.e4e2fbcd.svg";